import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION;

export const getReferalPdfForm = createAsyncThunk(
  'stop/getReferalPdfForm',

  async (params) => {
    const { cmpReferralUrl, authorization } = params;

    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION,
      },
    };

    try {
      const response = await axios.get(cmpReferralUrl, config);
      return response.data.data || null;
    } catch (error) {
      console.error('Error fetching PDF:', error);
      return null;
    }
  }
);

const referalPdfSlice = createSlice({
  name: 'stop/referalPdfForm',
  initialState: null,
  reducers: {
    resetReferalPdfForm: () => null,
  },
  extraReducers: {
    [getReferalPdfForm.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetReferalPdfForm } = referalPdfSlice.actions;

export default referalPdfSlice.reducer;
